import React, { type FC, type PropsWithChildren } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';

import { useRovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';

import { useIsManualTrial } from '../../services/eligibility-check/index.tsx';
import type { AsyncEligibilityConditionsQuery } from './__generated__/AsyncEligibilityConditionsQuery.graphql.ts';

type AsyncEligibilityConditionsProps = {
	entitlementId: string;
};

export const AsyncEligibilityConditions: FC<PropsWithChildren<AsyncEligibilityConditionsProps>> = ({
	entitlementId,
	children,
}) => {
	const manualTrialData = useLazyLoadQuery<AsyncEligibilityConditionsQuery>(
		graphql`
			query AsyncEligibilityConditionsQuery($entitlementId: ID!) {
				growthUnifiedProfile_getEntitlementProfile(entitlementId: $entitlementId) {
					lastKnownTrial {
						trialEndTimeStamp
						trialType
					}
				}
			}
		`,
		{
			entitlementId,
		},
	);

	const trialEndTimeStamp =
		manualTrialData.growthUnifiedProfile_getEntitlementProfile?.lastKnownTrial?.trialEndTimeStamp ??
		undefined;
	const trialType =
		manualTrialData.growthUnifiedProfile_getEntitlementProfile?.lastKnownTrial?.trialType ??
		undefined;
	const isManualTrial = useIsManualTrial(trialType, trialEndTimeStamp);

	const { data: rovoEntitlementData } = useRovoEntitlementResource();

	const isEligible = isManualTrial === true && rovoEntitlementData?.isRovoLLMEnabled === true;
	return isEligible ? <>{children}</> : <></>;
};
